export default class DownloadBinaryFile {

  static downloadBlob(blob, filename = 'file') {
    if (!blob) {
      throw new Error('Blob non valido')
    }

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = filename

    document.body.appendChild(link)
    link.click()

    link.remove()

    window.URL.revokeObjectURL(url)
  }
}